import axios, {AxiosError} from "axios"
import {apiClient} from "@commercehub/api-service"

const Auth = require("@cimpress/simple-auth-wrapper").centralizedAuth

export const CimpressAuth = new Auth({
	clientID: process.env.REACT_APP_AUTH0_CLIENT_ID,
	redirectUri: window.location.href,
	emitInitialTokenExpired: true,
})

let reauthInProgress = false

function recoverSession(): void {
	if (reauthInProgress) return
	reauthInProgress = true

	const nextUri = window.location.pathname + window.location.search

	CimpressAuth.removeToken()

	CimpressAuth.login({nextUri, forceLogin: false})
		.then((isAuthenticated: boolean) => {
			if (!isAuthenticated) {
				return CimpressAuth.login({nextUri, forceLogin: true})
			}
			return undefined
		})
		.catch((error: unknown) => {
			reauthInProgress = false
			console.error("Session recovery failed", error)
		})
}

CimpressAuth.on("tokenExpired", () => recoverSession())

CimpressAuth.on("authenticated", () => {
	reauthInProgress = false
	const token = CimpressAuth.getAccessToken()
	if (token) {
		localStorage.setItem("accessToken", token)
	}
	apiClient.refreshTokenFromStorage()
})

axios.interceptors.response.use(
	(response) => response,
	(error: AxiosError) => {
		if (error?.response?.status === 401) {
			recoverSession()
		}
		return Promise.reject(error)
	}
)

// @commercehub/api-service uses its own axios.create() instance, so the
// interceptor above never sees its 401s. Hook recovery into that instance too.
const commercehubAxios = (
	apiClient as unknown as {axiosInstance?: {interceptors: typeof axios.interceptors}}
).axiosInstance

if (commercehubAxios) {
	commercehubAxios.interceptors.response.use(
		(response) => response,
		(error: AxiosError) => {
			const status =
				error?.response?.status ?? (error as unknown as {statusCode?: number})?.statusCode
			if (status === 401) {
				recoverSession()
			}
			return Promise.reject(error)
		}
	)
}
